import React from "react";
import { CheckCircleIcon, XMarkIcon } from "@heroicons/react/24/outline";

interface SuccessMessageProps {
  message: string | null;
  onClose: () => void;
}

const SuccessMessage: React.FC<SuccessMessageProps> = ({
  message,
  onClose,
}) => {
  if (!message) return null;

  return (
    <div className="fixed bottom-4 right-4 z-[200] animate-fade-in-up">
      <div className="bg-white border-l-4 border-green-500 shadow-2xl rounded-xl p-4 flex items-center space-x-4 min-w-[300px]">
        <div className="flex-shrink-0">
          <CheckCircleIcon className="h-6 w-6 text-green-500" />
        </div>
        <div className="flex-1">
          <p className="text-sm font-bold text-gray-900 leading-tight">
            ສຳເລັດ!
          </p>
          <p className="text-xs text-gray-600 mt-0.5">{message}</p>
        </div>
        <button
          onClick={onClose}
          className="text-gray-400 hover:text-gray-600 transition-colors"
        >
          <XMarkIcon className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
};

export default SuccessMessage;
